import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const floatAnimation = {
  "@keyframes float": {
    "0%": { transform: "translateY(0px)" },
    "50%": { transform: "translateY(-10px)" },
    "100%": { transform: "translateY(0px)" }
  }
};

const WhyChooseUsHome = () => {
  const features = [
    {
      icon: "🚢",
      title: "Global Trade Experts",
      description:
        "We specialize in seamless import and export operations, ensuring smooth international trade for premium products.",
      delay: "0s"
    },
    {
      icon: "🧅 🧄",
      title: "Finest Quality of Garlic & Onion powders",
      description:
        "We source and export the best farm fresh Garlic and Onion powders, delivering farm-to-market excellence worldwide.",
      delay: "0.3s"
    },
    {
      icon: "🧂",
      title: "Authentic Spices Exporter",
      description:
        "Our high-quality Indian spices are sourced directly from farms, ensuring rich flavors and authenticity.",
      delay: "0.6s"
    },
    // {
    //   icon: "👕",
    //   title: "Premium Kids Garments",
    //   description:
    //     "We bring stylish and comfortable kids' wear, ensuring top-notch quality with trendy designs for international markets.",
    //   delay: "0.9s"
    // },
  
    {
      icon: "🤝",
      title: "Customer-First Approach",
      description:
        "We prioritize customer satisfaction by offering reliable service, on-time delivery, and premium quality assurance.",
      delay: "1.5s"
    }
  ];

  return (
    <Box
      sx={{
        px: { xs: 3, md: 8 },
        py: { xs: 6, md: 10 },
        textAlign: "center",
       
        borderRadius: "10px", // Soft edges for a modern feel
      }}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        sx={{
          color: "#4A2C2C", // Thematic color
          mb: 4,
        }}
      >
       
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {features.map((feature, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            sx={{
              textAlign: "center",
              mt: index >= 3 ? { xs: 4, md: 6 } : 0 // Adds spacing to second row
            }}
          >
            <Typography
              variant="h3"
              sx={{
                mb: 1,
                animation: "float 3s infinite ease-in-out",
                animationDelay: feature.delay,
                ...floatAnimation,
                color: "#4A2C2C", // Icon color
              }}
            >
              {feature.icon}
            </Typography>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                animation: "float 3s infinite ease-in-out",
                animationDelay: feature.delay,
                ...floatAnimation,
                color: "#4A2C2C", // Title color
              }}
            >
              {feature.title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                animation: "float 3s infinite ease-in-out",
                animationDelay: feature.delay,
                ...floatAnimation,
                color: "#333", // Keeps text readable with slight contrast
              }}
            >
              {feature.description}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WhyChooseUsHome;
